import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {MetaProgresso, MetaResponse} from '@core/models/meta';
import {MetaService} from '@core/services/meta.service';
import {Select} from 'primeng/select';
import {Skeleton} from 'primeng/skeleton';
import {Button} from 'primeng/button';
import {FormsModule} from '@angular/forms';
import {Router} from '@angular/router';
import {MetaProgressoPanel} from '@shared/components/meta-progresso-panel/meta-progresso-panel';

@Component({
  selector: 'app-meta-bonificacao',
  imports: [
    Select, Skeleton, Button, FormsModule, MetaProgressoPanel,
  ],
  templateUrl: './meta-bonificacao.html',
})
export class MetaBonificacao implements OnInit, OnDestroy {
  metas: MetaResponse[] = [];
  metaSelecionada: MetaResponse | null = null;
  progresso: MetaProgresso | null = null;
  loading = true;
  progressoLoading = false;
  autoRefresh = false;
  private refreshInterval: ReturnType<typeof setInterval> | null = null;

  private service = inject(MetaService);
  private router = inject(Router);

  ngOnInit() {
    this.carregarMetas();
  }

  ngOnDestroy() {
    this.pararRefresh();
  }

  private carregarMetas() {
    this.loading = true;
    this.service.listar().subscribe({
      next: data => {
        this.metas = data.filter(m => m.ativo);
        this.metaSelecionada = this.metas[0] ?? null;
        if (this.metaSelecionada) this.carregarProgresso();
        this.loading = false;
      },
      error: () => this.loading = false,
    });
  }

  onMetaChange() {
    if (this.metaSelecionada) this.carregarProgresso();
  }

  carregarProgresso() {
    if (!this.metaSelecionada) return;
    this.progressoLoading = true;
    this.service.getProgresso(this.metaSelecionada.id).subscribe({
      next: p => { this.progresso = p; this.progressoLoading = false; },
      error: () => this.progressoLoading = false,
    });
  }

  toggleAutoRefresh() {
    this.autoRefresh = !this.autoRefresh;
    if (this.autoRefresh) {
      this.refreshInterval = setInterval(() => this.carregarProgresso(), 30000);
    } else {
      this.pararRefresh();
    }
  }

  private pararRefresh() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  irParaAdmin() {
    this.router.navigate(['/admin/metas']);
  }
}
